export const getUserDisplayedName = user => {
  if (!user) {
    return "";
  }

  return `${user.firstName} ${user.lastName}`;
};
